module.exports = __webpack_public_path__ + "img/box-1-en.ca77b7eb.png";